import React from "react";

const Notification = ({ message, type, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor =
    {
      success: "#28a745",
      error: "#dc3545",
      warning: "#ffc107",
      info: "#17a2b8",
    }[type] || "#17a2b8";

  const textColor = type === "warning" ? "#212529" : "white";

  return (
    <div
      style={{
        background: bgColor,
        color: textColor,
        padding: "12px 20px",
        borderRadius: "4px",
        marginBottom: "10px",
        fontWeight: "500",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        animation: "slideIn 0.3s ease",
        maxWidth: "350px",
        wordWrap: "break-word",
      }}
    >
      {message}
    </div>
  );
};

const NotificationContainer = ({ notifications, onRemove }) => {
  if (notifications.length === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onClose={() => onRemove(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
